import { render, staticRenderFns } from "./AttaInfo.vue?vue&type=template&id=04b66038&scoped=true&"
import script from "./AttaInfo.vue?vue&type=script&lang=js&"
export * from "./AttaInfo.vue?vue&type=script&lang=js&"
import style0 from "./AttaInfo.vue?vue&type=style&index=0&id=04b66038&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b66038",
  null
  
)

export default component.exports